import { render, staticRenderFns } from "./dictTypeDialog.vue?vue&type=template&id=78bc9065&scoped=true&"
import script from "./dictTypeDialog.vue?vue&type=script&lang=js&"
export * from "./dictTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./dictTypeDialog.vue?vue&type=style&index=0&id=78bc9065&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bc9065",
  null
  
)

export default component.exports